import {IJobAddon, IJobType} from '../services/types';

export const FALLBACK_JOB_TYPES: IJobType[] = [
    {
        key: 'fachkraefte',
        display_name: 'Fachkräfte',
        description: 'Für qualifizierte Fachkräfte – Ihre Anzeige bleibt aktiv solange das Abo läuft.',
        price_monthly: 299,
        currency: 'EUR',
        is_free: false,
        expiration_days: null,
        stripe_product_id: null,
        stripe_price_id: null,
        plan_id: 0,
    },
    {
        key: 'hilfskraefte',
        display_name: 'Hilfskräfte',
        description: 'Für Hilfskräfte – kostenlos, Ihre Anzeige ist 60 Tage aktiv.',
        price_monthly: 0,
        currency: 'EUR',
        is_free: true,
        expiration_days: 60,
        stripe_product_id: null,
        stripe_price_id: null,
        plan_id: 0,
    },
];

export const FALLBACK_ADDONS: IJobAddon[] = [
    {key: 'logo', display_name: 'Firmenlogo', description: 'Ihr Logo wird neben der Stellenanzeige angezeigt.', price_monthly: 9, currency: 'EUR', stripe_product_id: null, stripe_price_id: null, flag_field: 'has_logo', plan_id: 0},
    {key: 'highlight', display_name: 'Hervorgehobene Anzeige', description: 'Ihre Anzeige wird farblich hervorgehoben.', price_monthly: 19, currency: 'EUR', stripe_product_id: null, stripe_price_id: null, flag_field: 'has_highlight', plan_id: 0},
    {key: 'top_position', display_name: 'Top-Anzeige', description: 'Ihre Anzeige wird ganz oben in den Suchergebnissen angezeigt.', price_monthly: 29, currency: 'EUR', stripe_product_id: null, stripe_price_id: null, flag_field: 'has_top_position', plan_id: 0},
    {key: 'email_distribution', display_name: 'E-Mail-Verteilung', description: 'Passende Kandidaten erhalten Ihre Anzeige per E-Mail.', price_monthly: 79, currency: 'EUR', stripe_product_id: null, stripe_price_id: null, flag_field: 'has_email_distribution', plan_id: 0},
    {key: 'direct_contact', display_name: 'Direktansprache', description: 'Kandidaten können Sie direkt kontaktieren.', price_monthly: 99, currency: 'EUR', stripe_product_id: null, stripe_price_id: null, flag_field: 'has_direct_contact', plan_id: 0},
];

export const getJobTypesWithFallback = (apiTypes?: IJobType[]): IJobType[] => {
    return (apiTypes && apiTypes.length > 0) ? apiTypes : FALLBACK_JOB_TYPES;
};

export const getAddonsWithFallback = (apiAddons?: IJobAddon[]): IJobAddon[] => {
    return (apiAddons && apiAddons.length > 0) ? apiAddons : FALLBACK_ADDONS;
};
